module.exports = __webpack_public_path__ + "img/E6BF3C_5A4719_977726_FCFC82-256px.3a32d4da.png";